var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 53,
    rx: 8.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 53,
    rx: 8.5,
    stroke: "#395B9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2133_14800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9972 21.0909C33.1452 18.6717 30.3291 17.2842 27.271 17.2842C25.121 17.2842 23.0823 17.9749 21.375 19.2818C20.7573 19.7547 20.1984 20.3015 19.7119 20.9051L19.2781 18.448C19.2306 18.1793 18.9741 17.9995 18.7056 18.0473L17.4082 18.2763C17.2791 18.2991 17.1645 18.3722 17.0893 18.4795C17.0141 18.5869 16.9847 18.7196 17.0075 18.8487L18.0382 24.6873C18.0806 24.927 18.289 25.0956 18.5242 25.0956C18.5527 25.0956 18.5817 25.0931 18.6107 25.088L24.4494 24.0573C24.7181 24.0098 24.8975 23.7536 24.8501 23.4849L24.621 22.1874C24.5982 22.0584 24.5252 21.9437 24.4178 21.8685C24.3104 21.7933 24.1777 21.764 24.0486 21.7867L21.6156 22.2163C21.9578 21.8118 22.3452 21.4428 22.7766 21.1126C24.0784 20.116 25.6331 19.5893 27.2725 19.5893C29.6058 19.5893 31.754 20.6475 33.1664 22.4925C34.3698 24.0643 34.8889 26.0107 34.6283 27.9731C34.3676 29.9355 33.3583 31.6789 31.7865 32.8821C30.4809 33.8816 28.9287 34.4098 27.2977 34.4098C26.9685 34.4098 26.6348 34.3877 26.3057 34.344C24.3434 34.0834 22.6 33.0742 21.3967 31.5023C20.6642 30.5456 20.172 29.4167 19.9731 28.2377C19.9513 28.1085 19.879 27.9932 19.7723 27.9173C19.6655 27.8413 19.5329 27.811 19.4037 27.8327L18.1045 28.0518C17.8355 28.0972 17.6542 28.3522 17.6995 28.6212C17.9606 30.169 18.6059 31.6499 19.5658 32.9038C21.1434 34.9647 23.4293 36.2879 26.0021 36.6296C26.4326 36.6868 26.8694 36.7158 27.3004 36.7158C29.4405 36.7158 31.4764 36.0232 33.1878 34.713C35.2488 33.1354 36.572 30.8495 36.9137 28.2766C37.2556 25.7037 36.5749 23.1518 34.9972 21.0909Z",
    fill: "#395B9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2133_14800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.13052ddb9bc5589d04dfb772065381f4.svg";
export { ForwardRef as ReactComponent };